




































































import { Component, Vue } from 'vue-property-decorator';
import { ElForm } from 'element-ui/types/form';
import { Action } from 'vuex-class';

interface RefsInterface {
    dynamicValidateForm: ElForm
}

interface Fields {
    email: string | null,

    [key: string]: string | null
}

@Component({
    name: 'ForgotPassword',
})
export default class ForgotPassword extends Vue {
    public $refs!: Vue['$refs'] & RefsInterface;


    protected dynamicValidateForm = {
        email: '',
    };

    protected errorMessages: Fields = {
        email: null,
    };

    protected isButtonEnabled = true;
    @Action('user/resetPassword') private resetPassword!: (email: string) => Promise<unknown>;

    protected submitForm(formName: keyof RefsInterface) {
        this.errorMessages.email = null;
        this.$refs[formName].validate((valid: boolean) => {
            if (valid) {
                this.isButtonEnabled = false;
                this.resetPassword(this.dynamicValidateForm.email).then(() => {
                    this.$emit('forget-password-initialized');
                }).catch((e) => {
                    e.response.data.errors.forEach(
                        (error: { detail: string, title: string, source: { pointer: string } }) => {
                            if (!error.source) {
                                this.$message.error(error.title);
                                return;
                            }
                            const pointerArray = error.source.pointer.split('/');
                            const pointer = pointerArray[pointerArray.length - 1];
                            this.errorMessages[pointer] = error.detail;
                        });
                    return new Error(e);
                }).finally(() => {
                    this.isButtonEnabled = true;
                });
            } else {
                for (const key in this.errorMessages) {
                    if (this.errorMessages.hasOwnProperty(key)) {
                        this.errorMessages[key] = null;
                    }
                }
                return false;
            }
        });
    }

    protected resetForm(formName: keyof RefsInterface) {
        this.$refs[formName].resetFields();
    }

}
